import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {SmartSelectResults} from '~components/models/samples/smart-select/SmartSelectResults';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/samples/smart-select-results')({
  component: SmartSelectResultsPage,
});

function SmartSelectResultsPage() {
  return (
    <ModelProvider mode='model-pages'>
      <BaseLayout showBackButton customContentAndFooter>
        <SmartSelectResults />
      </BaseLayout>
    </ModelProvider>
  );
}
